import React from "react";
import {
  Modal,
  Box,
  Typography,
  FormControlLabel,
  Switch,
  IconButton,
  Tooltip,
  Button,
} from "@mui/material";
import { Info as InfoIcon } from "@mui/icons-material";

export default function EventOverridesModal({
  open,
  onClose,
  event,
  hideFromPublicLists,
  hideEvent,
  onHideFromPublicListsChange,
  onHideEventChange,
  onSave,
  onCancel,
  saving,
}) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="edit-overrides-modal-title"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          border: "2px solid #000",
          boxShadow: 24,
          p: 4,
        }}
      >
        <Typography
          id="edit-overrides-modal-title"
          variant="h6"
          component="h2"
          sx={{ mb: 3 }}
        >
          Edit Superadmin Overrides
          {event && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              {event.name || "Unnamed Event"}
            </Typography>
          )}
        </Typography>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
          <Box display="flex" alignItems="center" gap={1}>
            <FormControlLabel
              control={
                <Switch
                  checked={hideFromPublicLists === true}
                  onChange={(e) => onHideFromPublicListsChange(e.target.checked)}
                />
              }
              label="Hide from public event lists"
            />
            <Tooltip title="If enabled, event will not appear in public event listings even if 'Include in public Event listings' is enabled.">
              <IconButton size="small" sx={{ padding: 0.5 }}>
                <InfoIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>

          <Box display="flex" alignItems="center" gap={1}>
            <FormControlLabel
              control={
                <Switch
                  checked={hideEvent === true}
                  onChange={(e) => onHideEventChange(e.target.checked)}
                />
              }
              label="Hide event"
            />
            <Tooltip title="If enabled, event will be completely hidden from public view.">
              <IconButton size="small" sx={{ padding: 0.5 }}>
                <InfoIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              mt: 2,
            }}
          >
            <Button onClick={onCancel} disabled={saving}>
              Cancel
            </Button>
            <Button variant="contained" onClick={onSave} disabled={saving}>
              {saving ? "Saving..." : "Save"}
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}
